<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title" >
        <span v-if='item.redirect==="noredirect"||index==levelList.length-1' class="no-redirect">{{generateTitle(item.meta.title)}}</span>
        <router-link v-else :to="item.redirect||item.path">{{generateTitle(item.meta.title)}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { generateTitle } from '@/utils/i18n'

export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    generateTitle,
    /*getBreadcrumb() {
      console.log('matched1',this.$route.matched)
      let matched = this.$route.matched.filter(item => item.path)
      console.log('matched2',matched)
      const first = matched[0]
      console.log('first',first)
      if (first && first.name !== 'index') {
        matched = [{ path: '/index', meta: { title: 'dashboard' }}].concat(matched)
      }
      console.log('matched3',matched)
      this.levelList = matched
      console.log('levelList',this.levelList)
    }*/
    getBreadcrumb() {
      // console.log('this.$route',this.$route);
      // console.log('matched1',this.$route.matched)
      let matched = this.$route.matched
      this.levelList = matched
      // console.log('levelList',this.levelList)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue